import React, { useState, useEffect } from 'react';
import Message from './Message';
import Upload from '../Documents/UploaderButton';

import '../../styles/Chat.scss';

export default class Chat extends React.Component {


  state = {
    messages: {}
  }

  refOject = {
    input: React.createRef(),
    messages: {}
  }

  async componentDidMount() {

    this.chat_container = document.getElementById('chat_message_list');

    await this.setState({
      messages: window.sdk.chat().getMessages()
    })
    this.scrollDown(true);

    window.sdk.event().on('newMessage', () => {
      this.forceUpdate();
      this.scrollDown();
    })

    window.sdk.event().on('deleteMessage', () => {
      this.forceUpdate();
    })

    this.chat_container.addEventListener('scroll', () => {
        if(this.chat_height <= (this.chat_container.offsetHeight + this.chat_container.scrollTop )){
          this.toggleScrollDown(false);
      }
    })    
  }

  scrollDown = (force = false) => {
    setTimeout(() => {
      try {
        let do_scroll = true;
        
        if(!this.chat_height){
          this.chat_height = this.chat_container.scrollHeight;
        }
        if(!force && this.chat_height > (this.chat_container.offsetHeight + this.chat_container.scrollTop + 1)){
          do_scroll = false;
        }
        this.chat_height = this.chat_container.scrollHeight;
        if(do_scroll){
          this.toggleScrollDown(false);
          this.chat_container.scrollTop = 10000000;
        } else {
          this.toggleScrollDown(true);
        }
      }
      catch (err) {

      }
    }, 30)    
  }
  
  
  toggleScrollDown(show) {
    if (show && document.getElementById('btn-show-messages').classList.contains('hide')) {
      this.checkScroll = false;
       document.getElementById('btn-show-messages').classList.remove('hide');
     }
     if(!show && !document.getElementById('btn-show-messages').classList.contains('hide')) {
       this.checkScroll = true;
       document.getElementById('btn-show-messages').classList.add('hide');
     }
   } 

  handleSend = (event) => {
    window.sdk.session().sendMessage(this.refOject.input.current.value);
    setTimeout(() => { this.refOject.input.current.value = '' }, 250);
  }

  handleKeyPress = (e) => {
    if (e.which == 13 && e.shiftKey) {
    }
    else if (e.key === 'Enter') {
      e.preventDefault();
      this.handleSend();
    }

  }

  showDragOverlay = (isDrag) => {
    console.log('showDragOverlay', isDrag)
    this.setState({isDrag})
  }

  render() {

    let messages = this.state.messages;

    return (
      <div className="chat" id="hoco_chat">
        {this.state.isDrag &&
          <div className="drop-overlay"><i className='icon-download' /></div>
        }
        <div className="chat_exit_button" onClick={() => {window.sdk.event().emit('toggleChat')}}></div>
        <div className={'chat_messages'}>
        <div id="btn-show-messages" className="hide scrolldown-messages" >
              <button className="btn blue " onClick={() => this.scrollDown(true)}>
                <span>Nouveaux messages</span>
              </button>
            </div>
          <ul id='chat_message_list'>
            <React.Fragment>
              {Object.keys(messages)
                .map((key, index) => {
                  return <Message key={key} ref={this.refOject.messages[index]} message={messages[key]} />
                })}
            </React.Fragment>
          </ul>
        </div>
        <div className="chat_message_action">
              <Upload dropZoneId={'hoco_chat'} onDrag={(isDrag)=> {this.showDragOverlay(isDrag)}} />
              <div className="chat_message_write">
                <textarea className="chat_message_form_input" id="chat_message_form_input" ref={this.refOject.input} onKeyPress={this.handleKeyPress} placeholder='YOUR MESSAGE...'></textarea>
                <button className="chat_message_send btn btn-icon btn-size2" onClick={this.handleSend}>
                  <i className='icon-plane' />
                </button>
              </div>
        </div>
      </div>
    );
  }

}